/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalCsmsConfigDto } from './ExternalCsmsConfigDto';
import {
    ExternalCsmsConfigDtoFromJSON,
    ExternalCsmsConfigDtoFromJSONTyped,
    ExternalCsmsConfigDtoToJSON,
    ExternalCsmsConfigDtoToJSONTyped,
} from './ExternalCsmsConfigDto';

/**
 * 
 * @export
 * @interface CreateOrganizationResponseDto
 */
export interface CreateOrganizationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationResponseDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrganizationResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationResponseDto
     */
    parentId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationResponseDto
     */
    organizationType: CreateOrganizationResponseDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationResponseDto
     */
    mainLanguage: CreateOrganizationResponseDtoMainLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationResponseDto
     */
    createdById?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationResponseDto
     */
    updatedById?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateOrganizationResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateOrganizationResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {ExternalCsmsConfigDto}
     * @memberof CreateOrganizationResponseDto
     */
    externalCsmsConfig?: ExternalCsmsConfigDto | null;
}


/**
 * @export
 */
export const CreateOrganizationResponseDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type CreateOrganizationResponseDtoOrganizationTypeEnum = typeof CreateOrganizationResponseDtoOrganizationTypeEnum[keyof typeof CreateOrganizationResponseDtoOrganizationTypeEnum];

/**
 * @export
 */
export const CreateOrganizationResponseDtoMainLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type CreateOrganizationResponseDtoMainLanguageEnum = typeof CreateOrganizationResponseDtoMainLanguageEnum[keyof typeof CreateOrganizationResponseDtoMainLanguageEnum];


/**
 * Check if a given object implements the CreateOrganizationResponseDto interface.
 */
export function instanceOfCreateOrganizationResponseDto(value: object): value is CreateOrganizationResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('mainLanguage' in value) || value['mainLanguage'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CreateOrganizationResponseDtoFromJSON(json: any): CreateOrganizationResponseDto {
    return CreateOrganizationResponseDtoFromJSONTyped(json, false);
}

export function CreateOrganizationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
        'parentId': json['parentId'],
        'organizationType': json['organizationType'],
        'mainLanguage': json['mainLanguage'],
        'createdById': json['createdById'] == null ? undefined : json['createdById'],
        'updatedById': json['updatedById'] == null ? undefined : json['updatedById'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'externalCsmsConfig': json['externalCsmsConfig'] == null ? undefined : ExternalCsmsConfigDtoFromJSON(json['externalCsmsConfig']),
    };
}

export function CreateOrganizationResponseDtoToJSON(json: any): CreateOrganizationResponseDto {
    return CreateOrganizationResponseDtoToJSONTyped(json, false);
}

export function CreateOrganizationResponseDtoToJSONTyped(value?: CreateOrganizationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'parentId': value['parentId'],
        'organizationType': value['organizationType'],
        'mainLanguage': value['mainLanguage'],
        'createdById': value['createdById'],
        'updatedById': value['updatedById'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'externalCsmsConfig': ExternalCsmsConfigDtoToJSON(value['externalCsmsConfig']),
    };
}

